import React from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import * as DepositInvoiceAction from 'store/actions/depositInvoice';
import DepositInvoiceList from 'pages/invoice/DepositInvoice/list';
import { getHeaders } from 'pages/invoice/DepositInvoice/headers';
import { t } from 'i18next';
import FilterBox from 'pages/invoice/DepositInvoice/filter';
import { useHistory } from 'react-router';
import queryString from 'query-string';

function SelectDepositInvoiceDialog({ modalOpen, onToggle, onSelect }) {
  const [searchValue, setSearchValue] = React.useState(null);
  const dispatch = useDispatch();
  const router = useHistory();

  const depositInvoices = useSelector((state) => state.depositInvoice.depositInvoices);

  React.useEffect(() => {
    if (modalOpen) {
      loadData();
    }
  }, [modalOpen]);

  const loadData = (value = null) => {
    setSearchValue(value);
    let query = { limit: 10, page: 1 };
    if (router.location.search) {
      const parsed = queryString.parse(router.location.search);
      query = { ...query, ...parsed };
    }
    dispatch(DepositInvoiceAction.getAll(query, value ? value : searchValue ? searchValue : {}));
  };

  const handleSelect = (invoice) => {
    onSelect(invoice);
    onToggle(false);
  };

  const handlePageChange = (page) => {
    const query = queryString.parse(router.location.search);
    query.page = page;
    router.push(`?${queryString.stringify(query)}`);
    loadData(searchValue);
  };

  return (
    <Modal isOpen={modalOpen} size='xl' backdrop={true} toggle={() => onToggle(false)}>
      <ModalHeader toggle={() => onToggle(false)}>
        {t('select')} {t('sidebar.deposit_invoice')}
      </ModalHeader>
      <ModalBody>
        <DepositInvoiceList
          headers={getHeaders(true)}
          data={depositInvoices}
          filter={
            <FilterBox
              onSearch={(value) => {
                loadData(value);
              }}
            />
          }
          onPageChange={handlePageChange}
          onChoose={handleSelect}
          canEdit={false}
          canDelete={false}
        />
      </ModalBody>
    </Modal>
  );
}

export default SelectDepositInvoiceDialog;
